import { apiDelete, apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';
import type {
  CreatePermissaoDominioDto,
  ListPermissoesDominioQuery,
  PermissaoDominio,
  PermissaoDominioDto,
  UpdatePermissaoDominioDto,
} from '@/types/escritorio/permissaoDominioTypes';

export const permissoesDominioService = {
  listar: async (
    escritorioId: string,
    filters?: ListPermissoesDominioQuery,
  ): Promise<PermissaoDominioDto[]> => {
    const params = new URLSearchParams();
    if (filters?.usuarioId) params.append('usuarioId', filters.usuarioId);
    if (filters?.dominio) params.append('dominio', filters.dominio);

    const queryString = params.toString();
    const url = `/escritorios/${escritorioId}/permissoes-dominio${queryString ? `?${queryString}` : ''}`;

    const response = await apiGet(url);
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao listar permissões por domínio' }));
      throw new Error(errorData.error || 'Erro ao listar permissões por domínio');
    }
    const result = await response.json();
    return result.data || [];
  },

  criar: async (
    escritorioId: string,
    data: CreatePermissaoDominioDto,
  ): Promise<PermissaoDominioDto> => {
    const response = await apiPost(`/escritorios/${escritorioId}/permissoes-dominio`, data);
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao criar permissão por domínio' }));
      throw new Error(errorData.error || 'Erro ao criar permissão por domínio');
    }
    const result = await response.json();
    return result.data;
  },

  atualizar: async (
    escritorioId: string,
    usuarioId: string,
    dominio: PermissaoDominio,
    data: UpdatePermissaoDominioDto,
  ): Promise<PermissaoDominioDto> => {
    const response = await apiPut(
      `/escritorios/${escritorioId}/permissoes-dominio/${usuarioId}/${dominio}`,
      data,
    );
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao atualizar permissão por domínio' }));
      throw new Error(errorData.error || 'Erro ao atualizar permissão por domínio');
    }
    const result = await response.json();
    return result.data;
  },

  remover: async (
    escritorioId: string,
    usuarioId: string,
    dominio: PermissaoDominio,
  ): Promise<void> => {
    const response = await apiDelete(
      `/escritorios/${escritorioId}/permissoes-dominio/${usuarioId}/${dominio}`,
    );
    if (!response.ok) {
      const errorData = await response
        .json()
        .catch(() => ({ error: 'Erro ao remover permissão por domínio' }));
      throw new Error(errorData.error || 'Erro ao remover permissão por domínio');
    }
  },
};
